<template>
	<div class="publiccartoon">
		<div class="Cartoon-con-one">
			<img
				:src="cartoon.cover_pic"
				alt
				class="Cartoon-con-one-left"
				@click="toCartooninfo(cartoon.id)"
			/>
			<div class="Cartoon-con-one-right">
				<p class="Cartoon-con-one-right-p" @click="toCartooninfo(cartoon.id)">{{cartoon.title}}</p>
				<p class="Cartoon-con-one-right-p1">作者：{{cartoon.author}}</p>
				<p class="Cartoon-con-one-right-p1">
					题材：
					<span v-for="(item, index) in cartoon.bookcate" :key="index">{{item}}</span>
				</p>
				<p class="Cartoon-con-one-right-p1" v-if="cartoon.status==2">
					状态：
					<span style="color:#212121">已完结</span>
				</p>
				<p class="Cartoon-con-one-right-p1" v-if="cartoon.status==1">
					状态：
					<span style="color:#E51313">连载中</span>
				</p>
				<p class="Cartoon-con-one-right-p2">{{cartoon.summary}}</p>
				<span class="Cartoon-con-one-right-p3">
					更新至：
					<span
						class="Cartoon-con-one-right-span"
					>{{cartoon.episodes.length>0?cartoon.episodes[0].title:''}}</span>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		//import引入的组件需要注入到对象中才能使用
		components: {},
		props: ["cartoon"],
		data() {
			//这里存放数据
			return {};
		},
		//监听属性 类似于data概念
		computed: {},
		//监控data中的数据变化
		watch: {},
		//方法集合
		methods: {
			toCartooninfo(id) {
				const InfoDetail = this.$router.resolve({
					name: "Catalog",
					query: { id: id }
				});
				window.open(InfoDetail.href, "_blank");
			}
		},
		//生命周期 - 创建完成（可以访问当前this实例）
		created() {},
		//生命周期 - 挂载完成（可以访问DOM元素）
		mounted() {},
		beforeMount() {}, //生命周期 - 挂载之前
		beforeUpdate() {}, //生命周期 - 更新之前
		updated() {}, //生命周期 - 更新之后
		beforeDestroy() {}, //生命周期 - 销毁之前
		destroyed() {}, //生命周期 - 销毁完成
		activated() {} //如果页面有keep-alive缓存功能，这个函数会触发
	};
</script>

<style>
	.publiccartoon {
		display: flex;
		flex-wrap: wrap;
	}
	.Cartoon-con-one {
		width: 380px;
		height: 250px;
		margin-right: 20px;
		margin-top: 30px;
		display: flex;
	}

	.Cartoon-con-one-left {
		width: 180px;
		height: 250px;
		margin-right: 16px;
		border-radius: 8px;
		cursor: pointer;
	}

	.Cartoon-con-one-right {
		width: 180px;
		position: relative;
	}

	.Cartoon-con-one-right-p {
		font-size: 18px;
		font-weight: bold;
		color: #212121;
		cursor: pointer;
	}

	.Cartoon-con-one-right-p:hover {
		color: #28a3b1;
	}

	.Cartoon-con-one-right-p1 {
		font-size: 14px;
		margin-top: 10px;
		color: #212121;
		line-height: 14px;
	}
	.Cartoon-con-one-right-p11 {
		font-size: 14px;
		line-height: 14px;
		margin-top: 10px;
		color: #d52e25;
	}

	.Cartoon-con-one-right-p2 {
		font-size: 14px;
		margin-top: 10px;
		color: #808080;
		display: -webkit-box;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 3;
		overflow: hidden;
	}

	.Cartoon-con-one-right-p3 {
		font-size: 14px;
		color: #808080;
		position: absolute;
		bottom: 0;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.Cartoon-con-one-right-span {
		font-size: 14px;
		color: #28a3b1;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/publiccartoon.vue